import { useState } from "react";
import Icon from "../../assets/icons/Icon";
import { isMobileView } from "./CommonFunctions";

const TextArea = ({
  starticon,
  label,
  placeholder,
  value,
  onChange,
  errorMessage,
  row,
  h,
   infoText,
  tooltipPosition = "bottom",
  tooltipOffset = "0",
  tooltipWidth = null,
}) => {
  const [showInfoText,setShowInfoText]=useState(false);
  return (
    <div className={`flex  flex-col w-full relative ${errorMessage ? "mb-3": ""}`} >
      {label && (
        <label className={`mb-1 ${errorMessage ?"text-red-700":""}`}>
          {label}   
          {infoText && (
            <div className="relative inline-flex group">
              <span onClick={()=>{setShowInfoText(!showInfoText)}} onMouseEnter={()=>{setShowInfoText(true)}} onMouseLeave={()=>{setShowInfoText(false)}} className="inline-flex items-center justify-center ml-1 border border-[rgb(108,113,138)] text-[rgb(108,113,138)] rounded-full w-4 h-4 text-center leading-4 text-xs cursor-pointer">
                i
              </span>
{showInfoText && (
  <div
    className={`
      z-50 px-3 py-2 rounded whitespace-normal
      ${isMobileView()
        ? `fixed left-0 justify-center flex w-full bg-[#4A1E73] text-[#FFFFFF] top-0 }`
        : `
          absolute bg-[#4A1E73] text-[#FFFFFF] 
          ${getTooltipPositionClasses(tooltipPosition)}
          ${tooltipOffset ? `m-${tooltipOffset}` : ""}
        `
      }
    `}
    style={{
      width: isMobileView() ? "100%" : tooltipWidth || undefined,
    }}
  >
    {isMobileView() && (
      <span
        className="absolute top-2 right-2 w-6 h-6 bg-red-500 rounded-full flex items-center justify-center cursor-pointer shadow-lg hover:bg-red-600 transition-colors"
        onClick={(e) => {
          e.stopPropagation();
          setShowInfoText(false);
        }}
        aria-label="Close tooltip"
      >
        <span className="w-4">
          <Icon type="remove" />
        </span>
      </span>
    )}
    {infoText}
  </div>
)}

            </div>
          )}
        </label>
      )}
      {/* Apply the height to the container */}
      <div
        style={h ? { height: h } : {}}
        className={`flex relative w-full  text-gray-700 font-medium  rounded-lg duration-300 resize-none ${
          errorMessage ? "border-red-700 border" : "border border-[#d7d5e2] hover:border-[#408dfb] focus-within:shadow-[0_0_0_3px_rgba(64,_141,_251,_0.16)]"
        }`}
      >
        {starticon && (
          <span className="w-5 ml-2 mt-2 inline-block  hover:text-blue-600 focus-within:text-blue-600 focus:text-blue-600 rounded-lg">
            <Icon type={starticon} />
          </span>
        )}
        {/* Let the textarea fill its container */}
        <textarea
          rows={row}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          style={{ height: "100%" }}
          className="px-3 py-2 border-none w-full outline-none"
        />
      </div>
      {errorMessage && (
        <p className="mt-1  top-full  absolute text-red-700">
          {errorMessage}
        </p>
      )}
    </div>
  );
};
const getTooltipPositionClasses = (position) => {
  switch(position) {
    case 'top': return 'bottom-full left-1/2 -translate-x-1/2 mb-2';
    case 'bottom': return 'top-full left-1/2 -translate-x-1/2 mt-2';
    case 'left': return 'right-full top-1/2 -translate-y-1/2 mr-2';
    case 'right': return 'left-full top-1/2 -translate-y-1/2 ml-2';
    default: return 'bottom-full left-1/2 -translate-x-1/2 mb-2';
  }
};

export default TextArea;
